import { css } from 'styled-components';
var styles = css([".stars_block{min-width:100px;}.nva-star__star-icon{display:inline-block;filter:drop-shadow(0px 1px 0.2px rgba(0,0,0,0.7));}p{margin:0;padding:0;}"]);
export default styles;